import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueResource from 'vue-resource'

import i18n from '@/libs/i18n'
import { startSessionRefresh } from '@/auth/sessionRefresh'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
// import './signalr-hub'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/vue-easy-lightbox'
import signalRHub from './signalr-hub'

Vue.use(VueResource)
const { VUE_APP_API_BASE_URL } = process.env
Vue.http.options.root = VUE_APP_API_BASE_URL

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
// require('dotenv').config()

Vue.config.productionTip = false

Vue.use(signalRHub)

// Renew the 120 min JWT in the background while a tab is open. Without this, every protected
// route failed silently after two hours — and the call claim failed OPEN, which is how an agent
// ended up sharing a visitor with the telephone fallback (HT031-218). Safe to start while logged
// out: each tick does nothing until a token exists.
startSessionRefresh()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
